module.exports = __webpack_public_path__ + "media/images/mapRed-19587704bb4be293c6c759af87912397.svg";